import React from 'react'
import styles from './A23GameMenu.module.css';
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '../../ui/sheet';
import { FaBars, FaPalette, FaHeart, FaUserSlash, FaTimes, FaTrophy, FaWallet, FaPlus, FaCog, FaHome, FaInfoCircle, FaSignOutAlt } from "react-icons/fa";
// import GameIconButton from '../../GameIconButton/GameIconButton';
import { GameIconButton } from '@themed-components';
import { useNavigate } from 'react-router';
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import useActiveGame from '@/src/hooks/data/useActiveGame';
import { Switch } from '../../ui/switch';
import useActiveGames from '@/src/hooks/data/useActiveGames';
import { 
  useSitOutOption,
  usePlayerSitOutTimer,
  usePlayerSeat as useGamePlayerSeat,
  useGameDefinition
} from '@/src/hooks/data/useGameTable';
import usePlayerBalance from '@/src/hooks/data/usePlayerBalance';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import { doesExist } from '@/Common/utils/GameUtils';
import { TABLE_SETTINGS, GAME_INFO, EXIT_TABLE_CONFIRM, LEAVE_SEAT_CONFIRM } from '@/Poker/data/Constants';
import useRoomDetails from '@/src/hooks/data/useRoomDetails';
import useAddGameToFavorite from '@/src/hooks/utils/useAddGameToFavorite';
import useGameConnection from '@/src/hooks/data/useGameConnection';
import useLobbyConnectionStatus from '@/src/hooks/data/useLobbyConnectionStatus';

export default function A23GameMenu({ setActiveDrawer }) {
    const navigate = useNavigate();
    const tempTableId = useActiveGame();
    const activeGames = useActiveGames();
    const sitOutOption = useSitOutOption(tempTableId);
    const playerSitOutTimer = usePlayerSitOutTimer(tempTableId);
    const playerSeat = useGamePlayerSeat(tempTableId);
    const { totalBalance } = usePlayerBalance();
    const { sendLeaveSeatProtocol, sendExitGameProtocol, triggerExitTableFlow, sendSitOutProtocol, sendSitInProtocol, sendCancelSitOutProtocol } = useGameSocket(tempTableId);
    const { connected } = useGameConnection(tempTableId);
    const { connected: lobbyConnected } = useLobbyConnectionStatus();

    const gameDefinition = useGameDefinition(tempTableId);
    const roomId = gameDefinition?.roomId;
    const roomDetails = useRoomDetails(roomId);
    const { handleSaveFavoriteRequest } = useAddGameToFavorite({ isGame: true, roomId: roomId });

    const options = [
        {
            label: 'Go to lobby',
            icon: <FaHome size={18} />,
            isSwitch: false,
            action: () => {
                // Check the navigation stack, if there is no previous page, navigate to /
                if (window.history.length > 1) {
                    navigate(-1, { replace: true });
                } else {
                    // If there's no previous page in the stack, navigate to home
                    navigate('/', { replace: true });
                }
            },
            isClose: true,
        },
        {
            label: 'Table Themes',
            icon: <FaPalette size={18} />,
            isSwitch: false,
            action: () => {
                // TODO: Implement table themes
            },
            isClose: true,
        },
        connected ? {
            label: 'Table Settings',
            icon: <FaCog size={18} />,
            isSwitch: false,
            action: () => {
                // TODO: Implement table settings
                setActiveDrawer(TABLE_SETTINGS);
            },
            isClose: true,
        } : null,
        lobbyConnected ? {
            label: 'Add to favourite',
            icon: <FaHeart size={18} />,
            value: roomDetails?.isFavorite,
            isSwitch: true,
            action: () => {
                handleSaveFavoriteRequest(roomId);
            },
            isClose: true,
        } : null,
        connected && doesExist(playerSeat) ? {
            label: 'Sit Out',
            icon: <FaUserSlash size={18} />,
            value: sitOutOption,
            isSwitch: true,
            action: () => {
                // TODO: Implement sit out
                if (sitOutOption) {
                    if (playerSitOutTimer) {
                        sendSitInProtocol();
                    } else {
                        sendCancelSitOutProtocol();
                    }
                } else {
                    sendSitOutProtocol();
                }
            },
            isClose: true,
        } : null,
        connected && doesExist(playerSeat) ? {
            label: 'Leave seat',
            icon: <FaSignOutAlt size={18} />,
            isSwitch: true,
            action: () => {
                setActiveDrawer(LEAVE_SEAT_CONFIRM);
            },
            isClose: true,
        } : null,
        {
            label: 'Exit table',
            icon: <FaTimes size={18} />,
            isSwitch: false,
            action: () => {
                // if (activeGames.length === 1) {
                //     navigate(-1, { replace: true });
                // }
                // triggerExitTableFlow()
                setActiveDrawer(EXIT_TABLE_CONFIRM);
            },
            isClose: true,
        },
    ]

    // Mock user balance - replace with actual user data

    return (
        <Sheet>
            <SheetTrigger className={styles.filterButton}>
                <GameIconButton>
                    <FaBars />
                </GameIconButton>
            </SheetTrigger>
            <SheetContent side="left" className={styles.gameMenuSheetContent}>
                <div className={styles.gameMenuHeader}>
                    <span>Game Controls</span>
                </div>
                <div className={styles.gameMenuContainer}>
                    <div className={styles.gameMenuOptions}>
                        {options.map((option, index) => {
                            if (!option) return null;
                            return option.isClose ?
                                <SheetClose
                                    onClick={option.isSwitch ? undefined : option.action}
                                >
                                    <div
                                        key={index}
                                        className={styles.gameMenuOption}
                                    >
                                        <div className={styles.optionContent}>
                                            <span className={styles.optionIcon}>{option.icon}</span>
                                            <label htmlFor={'switch-' + option.label} className={styles.optionLabel}>{option.label}</label>
                                        </div>
                                        {option.isSwitch && (
                                            <Switch
                                                id={'switch-' + option.label}
                                                checked={option.value}
                                                onCheckedChange={option.action}
                                            />
                                        )}
                                    </div>
                                </SheetClose>
                                :
                                <div
                                    key={index}
                                    className={styles.gameMenuOption}
                                    onClick={option.isSwitch ? undefined : option.action}
                                >
                                    <div className={styles.optionContent}>
                                        <span className={styles.optionIcon}>{option.icon}</span>
                                        <label htmlFor={'switch-' + option.label} className={styles.optionLabel}>{option.label}</label>
                                    </div>
                                    {option.isSwitch && (
                                        <Switch
                                            id={'switch-' + option.label}
                                            checked={option.value}
                                            onCheckedChange={option.action}
                                        />
                                    )}
                                </div>
                        })}
                    </div>

                    <div className={styles.bottomSection}>
                        <div className={styles.bottomRow}>
                            <SheetClose onClick={() => setActiveDrawer(GAME_INFO)} className={styles.bottomButton}>
                                <FaInfoCircle size={16} />
                                <span>Game Info</span>
                            </SheetClose>
                            <SheetClose className={styles.bottomButton}>
                                <FaTrophy size={16} />
                                <span>Hand Rankings</span>
                            </SheetClose>
                        </div>
                        <div className={styles.bottomRow}>
                            <div className={styles.walletInfo}>
                                <FaWallet size={16} />
                                <span className={styles.balance}>{RUPEE_SYMBOL + totalBalance}</span>
                            </div>
                            <SheetClose className={styles.addCashButton}>
                                <FaPlus size={14} />
                                <span>Add Cash</span>
                            </SheetClose>
                        </div>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    )
} 